<!-- `webviewer.component.html` -->
<!-- Simple DOM element for WebViewer to populate -->
<div className="page">
  <div #viewer className="viewer" style="height: 100vh;"></div>
</div>